import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Определяем код ошибки из пути или статуса
  const getErrorInfo = () => {
    const path = location.pathname;
    if (path.includes('/404')) {
      return { code: 404, message: 'Страница не найдена', description: 'Запрашиваемая страница не существует.' };
    } else if (path.includes('/400')) {
      return { code: 400, message: 'Неверный запрос', description: 'Сервер не может обработать запрос из-за неверного синтаксиса.' };
    } else if (path.includes('/500')) {
      return { code: 500, message: 'Внутренняя ошибка сервера', description: 'На сервере произошла ошибка. Пожалуйста, попробуйте позже.' };
    } else if (path.includes('/403')) {
      return { code: 403, message: 'Доступ запрещен', description: 'У вас нет доступа к этой странице.' };
    } else {
      return { code: 404, message: 'Страница не найдена', description: 'Запрашиваемая страница не существует.' };
    }
  };

  const errorInfo = getErrorInfo();

  return (
    <div className="error-page">
      <Header />
      <div className="error-container">
        <div className="error-content">
          <div className="error-code">{errorInfo.code}</div>
          <h1 className="error-title">{errorInfo.message}</h1>
          <p className="error-description">{errorInfo.description}</p>
          <div className="error-actions">
            <button 
              className="btn-primary"
              onClick={() => navigate('/')}
            >
              На главную
            </button>
            <button 
              className="btn-secondary"
              onClick={() => navigate(-1)}
            >
              Назад
            </button>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;

